import React, { useState, useEffect } from 'react';
import api from '../services/api';

const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const th = { padding: '0 12px 10px 0', color: '#9AA3AE', fontSize: '10.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '11px 12px 11px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };

export default function Fornecedores() {
  const [lista, setLista] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get('/fornecedores').then(r => setLista(r.data)); }, []);

  const salvar = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (form.id) await api.put('/fornecedores/' + form.id, form);
      else await api.post('/fornecedores', form);
      setModal(false); setForm({});
      api.get('/fornecedores').then(r => setLista(r.data));
    } catch (err) { alert(err.response?.data?.error || 'Erro'); }
    finally { setLoading(false); }
  };

  const inp = (label, campo) => (
    <div style={{ marginBottom: '12px' }}>
      <label style={lbl}>{label}</label>
      <input value={form[campo] || ''} onChange={e => setForm({ ...form, [campo]: e.target.value })} style={inpStyle} />
    </div>
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533' }}>
          Fornecedores <span style={{ fontSize: '14px', color: '#6B7A8D', fontWeight: '400' }}>({lista.length})</span>
        </div>
        <button onClick={() => { setForm({}); setModal(true); }}
          style={{ padding: '9px 18px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
          + Novo Fornecedor
        </button>
      </div>

      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '16px 18px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Nome', 'CPF/CNPJ', 'Telefone', 'Email', ''].map(h => <th key={h} style={th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {lista.length === 0 && (
              <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: '#9AA3AE', padding: '32px 0' }}>Nenhum fornecedor cadastrado</td></tr>
            )}
            {lista.map(f => (
              <tr key={f.id}>
                <td style={{ ...td, fontWeight: '500' }}>{f.nome}</td>
                <td style={{ ...td, color: '#6B7A8D', fontFamily: "'DM Mono',monospace", fontSize: '12px' }}>{f.cpf_cnpj}</td>
                <td style={{ ...td, color: '#6B7A8D' }}>{f.telefone}</td>
                <td style={{ ...td, color: '#6B7A8D' }}>{f.email}</td>
                <td style={td}>
                  <button onClick={() => { setForm(f); setModal(true); }}
                    style={{ padding: '4px 10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#1A3A5C', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                    Editar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,25,40,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '28px 32px', width: '420px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1C2533', margin: 0 }}>{form.id ? 'Editar' : 'Novo'} Fornecedor</h3>
              <button onClick={() => { setModal(false); setForm({}); }} style={{ background: 'none', border: 'none', fontSize: '20px', color: '#9AA3AE', cursor: 'pointer' }}>×</button>
            </div>
            <form onSubmit={salvar}>
              {inp('Nome', 'nome')}
              {inp('CPF/CNPJ', 'cpf_cnpj')}
              {inp('Telefone', 'telefone')}
              {inp('Email', 'email')}
              {inp('Endereço', 'endereco')}
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <button type='button' onClick={() => { setModal(false); setForm({}); }}
                  style={{ flex: 1, padding: '10px', background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D', borderRadius: '8px', cursor: 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                  Cancelar
                </button>
                <button type='submit' disabled={loading}
                  style={{ flex: 1, padding: '10px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
                  {loading ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
